<script>
    import { Flex, Text } from "@axel669/zephyr"
</script>

<Flex ws="b: 1px solid hsl(@primary, @layer-border);">
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        Content
    </Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        More content
    </Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        Event more content
    </Text>
</Flex>

<br />

<Flex ws="fl.dir: row; b: 1px solid hsl(@primary, @layer-border);">
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        Content
    </Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        More content
    </Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">
        Event more content
    </Text>
</Flex>
